module.exports = __webpack_public_path__ + "static/media/core-return-starter.d0170567.png";